import { textHighlightPlugin } from './plugin'

export const initTextHighlightPlugin = () => {
  if (CKEDITOR.plugins.get('texthighlight')) {
    return
  }

  CKEDITOR.plugins.add('texthighlight', textHighlightPlugin)
}
